// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "@microsoft/applicationinsights-core-js";
export var StorageProviders = (/*@__PURE__*/createEnumStyle({
    LocalStorage: 1 /* eStorageProviders.LocalStorage */,
    SessionStorage: 2 /* eStorageProviders.SessionStorage */,
    IndexedDb: 3 /* eStorageProviders.IndexedDb */
}));
//# sourceMappingURL=IOfflineProvider.js.map